import { buildService } from './decorated-service';
import {
  StaticTransferApplication,
  OptionalStaticTransferApplication,
  TransferApplication
} from '../../../core/types/applications/transfer-application';
import {
  handleSubmissionError,
  purgeEmptyFields,
  removeExtraAddressFields,
  submissionTimeOutErrorCode
} from './util';
import { consumerTypes } from '../utils';

const api = buildService(
  '/new-account-svc/service/v2/account/mutualfund-transfer-ira'
);

const fonasuApi = buildService(
  '/new-account-svc/service/front-office/v2/account/mutualfund-transfer-ira'
);

// TODO [2021-02-01]: register flow with new Retirment Transfer Application State using generics
export const createTransferApplicationService = (
  args: OptionalStaticTransferApplication,
  consumerName
): Promise<any> => {
  // Need to remove accountName from externalAccounts
  const { externalAccounts } = args;
  const trimmedExternalAccounts = externalAccounts?.map(acct => {
    const {
      accountNumber,
      liquidationOption,
      estimatedTransferAmount,
      accountType,
      cusip
    } = acct;
    return {
      accountNumber,
      liquidationOption,
      estimatedTransferAmount,
      accountType,
      cusip
    };
  });

  const newApplicationParams = {
    ...args,
    externalAccounts: trimmedExternalAccounts
  };

  // TODO [2021-02-01]: register flow with new generic types for account type submissions
  const validated: StaticTransferApplication = TransferApplication.check(
    newApplicationParams
  );
  const submissionPayload = purgeEmptyFields(validated);
  const finalSubmissionPayload = removeExtraAddressFields(submissionPayload);

  const apiEndpoint = consumerName === consumerTypes.FONASU ? fonasuApi : api;

  return apiEndpoint.add(finalSubmissionPayload, {
    submissionTimeOutErrorCode,
    handleServiceResponse: handleSubmissionError
  });
};
